import styles from "./chatFileInner.module.scss";
import iconmusic from "../../../../styles/images/grid_music.svg";
import iconpdf from "../../../../styles/images/filepdf.svg";
import iconppt from "../../../../styles/images/fileppt.svg";
import iconword from "../../../../styles/images/fileword.svg";
import iconxls from "../../../../styles/images/fileexcel.svg";
import iconzip from "../../../../styles/images/filezip.svg";
import iconotherformat from "../../../../styles/images/otherformat.svg";
import iconotsupport from "../../../../styles/images/hiddenimage.svg";
import iconarrow from "../../../../styles/images/viewarrow.svg";
import iconvideo from "../../../../styles/images/Mp4.svg";
import React, { useState } from "react";
import { mp3Formats, zipFormats, pdfFormats, wordFormats, pptFormats, excelFormats,videoFormat, getFileSize } from "../../../../base/utils";


type replyMessageProps = {

  replyingMessage?: any;
  data?:any;
  groupdata?:any;
}
type fileMessageState = {
  isOpen: boolean;
  id: any;
};
export default function CloudReplyImage({replyingMessage,data,groupdata}:replyMessageProps) {
  let dataRes = data && data !== undefined? data:"";
  const [fileState, setfileState] = useState<fileMessageState>({
    isOpen: false, id: ""
    
  });
  const [longText, setlongtext] = useState(0);
 
 
  const readMoreChange = ()=>{
    setlongtext(1);
  }
  let mstext:any = data?.message?.body?.text;
  if(mstext && mstext !== ""){
    if (mstext?.length > 760 && longText === 0) {
      mstext = mstext.substring(0, 760) + "...";
    }
  }
 
  return (
    <>
   
      <div className={styles.chatContent}>
     {dataRes ==="" && <div className={styles.filesChat}>
          <div className={styles.filesImage}>
            <img src={
              mp3Formats.indexOf(replyingMessage?.fileType) !== -1 ?iconmusic:
              zipFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconzip :
                pdfFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconpdf:
                  wordFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconword:
                    pptFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconppt:
                      excelFormats.indexOf(replyingMessage?.fileType) !== -1 ? iconxls :iconotherformat}
            alt="filename" />
            </div>
          <div className={styles.filesDetails}>
            <span className={styles.fileName}>
              {replyingMessage?.fileName && replyingMessage?.fileName.substring(0,20)}</span>
            <span className={styles.fileDt}>File size:{getFileSize(replyingMessage?.filesize)}</span>
          </div>
      </div> }
           
      {dataRes !== "" &&  
      mp3Formats.indexOf(replyingMessage?.fileType) === -1  && videoFormat.indexOf(replyingMessage?.fileType) === -1  &&
       <div className={styles.filesChat} onClick={() => {window.open(data.message?.body?.filePath)}}>
          <div className={styles.filesImage}>
            <img src={   iconotsupport}   alt="filename" />
            </div>
          <div className={styles.filesDetails}>
          <p> {replyingMessage?.fileName && replyingMessage?.fileName.substring(0,20)}</p>
              <span className={styles.fileDt}>{getFileSize(replyingMessage?.filesize)}</span>
              { replyingMessage?.isCloudfiles  && <span className={styles.fileDt}>{replyingMessage?.filePath.includes('https://app.box.com') ? 'File from Box'  : " File from Drive" }</span>}

           </div>
          {replyingMessage?.isCloudfiles && <div className={styles.forarrowview}>
             <img src={iconarrow} alt=""/></div>}
         </div> }
     
 
      </div>
    </>
  );
};
